import { BAPI_COMMANDS } from "@/bapi-client/types/commands";
import { fetchHandler } from "@/bapi-client/fetch";
import { Result } from "../types";
import { ReportingGroupResponse } from "../types/autocomplete";

export async function getReportingGroups(
  customerId: string,
  search_term?: string,
): Promise<Result<ReportingGroupResponse>> {
  const path = `/reports/${customerId}/groups`;
  const query = new URLSearchParams();
  query.append("include_hidden", "false");
  if (search_term) {
    query.append("search_term", search_term);
  }

  const fullPath = `${path}?${query.toString()}`;
  const response = await fetchHandler(BAPI_COMMANDS.GET_REPORTING_GROUPS, "GET", fullPath);

  if (!response.success) {
    return response;
  }

  const { data } = response;
  const jsonResult = await data.json();

  return !jsonResult.success ? jsonResult : { success: true, data: jsonResult.data };
}
